import React from 'react';
import {BaseModal} from '../comun/Index';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      descripcion:"",
      asignacion_id:null,
      tipoModal:""
    }
  }

  componentDidMount(){
    const {asignacion_id,tipoModal} = this.props;
    this.setState({asignacion_id,tipoModal})
  }

  botones(){
    return (
      [
        {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
        {titulo:"Guardar", backgroundColor:'#00a5e5', onClick: () => this.props.guardar(this.state)}
      ]
    )
  }

  render(){
    const {tipoModal} = this.props;
    const {descripcion} = this.state;
    return(
      <BaseModal
        titulo={tipoModal}
        loading={false}
        botonera={this.botones()}
      >
        <textarea
          style={{resize:'none'}}
          rows={3}
          value={descripcion}
          onChange={(e) => this.setState({descripcion:e.target.value})}
        >
        </textarea>
      </BaseModal>
    );
  }
}

export default Modal;
